import { clone } from '@jkhy/frontend-utils/functions';
import { Nullable } from '@jkhy/frontend-utils/types';
import { WireFileModelDto } from '@treasury/api/channel';
import { format } from 'date-fns';
import { DomainEntity } from '../shared';
import { nullWireFile } from './wire-file.dto';

export class WireFile extends DomainEntity<Nullable<WireFileModelDto>> {
    constructor(dto = clone(nullWireFile)) {
        super(dto);
    }

    public createDefault(): this {
        return new WireFile(this.dto) as this;
    }

    public get wireFileId() {
        return this.dto.wireFileId;
    }

    public get fileName() {
        return this.dto.fileName || '';
    }

    public get amount() {
        return this.dto.amount || 0;
    }

    public get uploadedBy() {
        return this.dto.uploadedBy || '';
    }

    public get uploadDate() {
        if (this.dto.uploadDate) {
            return format(new Date(this.dto.uploadDate || ''), 'P');
        }
        return undefined;
    }

    public get processedBy() {
        return this.dto.processedBy || '';
    }

    public get processedDate() {
        if (this.dto.processedDate) {
            return format(new Date(this.dto.processedDate || ''), 'P');
        }
        return undefined;
    }

    public get fileSize() {
        return this.dto.fileSize || '';
    }

    public get totalWireCount() {
        return this.dto.totalWireCount || 0;
    }

    public get approvedCount() {
        return this.dto.approvedCount || 0;
    }

    public get pendingCount() {
        return this.dto.pendingCount || 0;
    }

    public get rejectedCount() {
        return this.dto.rejectedCount || 0;
    }

    public get expiredCount() {
        return this.dto.expiredCount || 0;
    }
}
